import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import DuplicateUserSearchStore from './DuplicateUserSearchStore'
import GapDialog from 'reusable/gap-dialog/GapDialog'
import GapDataGrid from 'reusable/mui/data-grid/GapDataGrid'
import IconButton from '@mui/material/IconButton'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { snackbarSuccess } from 'reusable/mui/snackbar/snackbar'

export default observer(function DuplicateUserSearch() {
   const duplicateUserSearchStore = useStore(() => new DuplicateUserSearchStore())

   return <>
      <Grid container gap={1}>
         <Grid size={3}>
            <Typography variant="body1">Search for duplicate users</Typography>
         </Grid>
         <Grid size={5}>
            <ButtonWithProgress
               loading={duplicateUserSearchStore.duplicateUserLoader.isLoading}
               variant="outlined"
               onClick={duplicateUserSearchStore.searchDuplicateUsers}>
               Search duplicates
            </ButtonWithProgress>
         </Grid>
      </Grid>

      {!duplicateUserSearchStore.duplicateUsers.length && duplicateUserSearchStore.duplicateUserLoader.hasLoadedAtleastOnce && <Typography variant="body1">No duplicate users found</Typography>}
      {!!duplicateUserSearchStore.duplicateUsers.length && <Stack sx={{ gap: 2, mt: 2 }}>
         <Typography variant="h5">Duplicate users:</Typography>
         <GapDataGrid
            columns={duplicateUserSearchStore.mainColumns}
            rows={duplicateUserSearchStore.duplicateUsers}
            loading={duplicateUserSearchStore.duplicateUserLoader.isLoading}
            onRowClick={duplicateUserSearchStore.handleMainRowClick}
            sortBy="count"
            noRowsText="No duplicate users found"
         />
      </Stack>}

      <GapDialog
         modalState={duplicateUserSearchStore.detailsModal}
         title={`Duplicate users for ${duplicateUserSearchStore.selectedEmail?.email}`}
         size="large"
      >
         {duplicateUserSearchStore.selectedEmail && <Stack gap={2} sx={{ minHeight: '500px' }}>
            <GapDataGrid
               columns={duplicateUserSearchStore.detailsColumn}
               rows={duplicateUserSearchStore.detailsRows}
               hideToolbar
            />
         </Stack>}
      </GapDialog>
   </>
})

export const CopyButton = (email: string) => {
   const copy = () => {
      navigator.clipboard.writeText(email)
      snackbarSuccess('Email copied to clipboard')
   }

   return <IconButton
      size="small"
      onClick={copy}
      title="Copy email">
      <ContentCopyIcon fontSize="small" />
   </IconButton>
}

